import { Column } from '@app/modules/table/classes/column.class';
import { CellDisplay } from '@app/modules/table/enums/cell-display.enum';

export class SentimentTypeColumn extends Column {
    title = 'performance.feedbackColumns.type';
    property = 'type';
    sortable = false;
    type: CellDisplay = CellDisplay.sentiment;
}
